export default __webpack_public_path__ + "static/media/icon-our-goal-mobile1.74b29d44.svg";